import { FingerprintjsProAngularModule } from '@fingerprintjs/fingerprintjs-pro-angular';

import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApIconComponent } from '@ap/icon';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { ApLoggingModule } from '@ap/logging';
import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApModalComponent } from '@ap/modal';
import { ApNotificationComponent } from '@ap/notification';
import { ApPersistenceModule } from '@ap/persistence';
import { ApSignComponent } from '@ap/sign';
import { ApInputComponent } from '@ap/input';
import { ApCardComponent } from '@ap/card';

import { LoginAccordionModule } from '../../klant/login/accordion/login-accordion.module';
import { SignModule } from '../../klant/login/sign/sign.module';

import Auth0loginWrapperComponent from './auth0login.wrapper.component';

/**
 * @ngdoc module
 * @name Auth0loginWrapperModule
 */
@NgModule({
    declarations: [Auth0loginWrapperComponent],
    imports: [
        AsyncPipe,
        ApAnalyticsModule,
        ApButtonComponent,
        ApContentPipe,
        ApContentComponent,
        ApLoggingModule,
        ApModalComponent,
        ApNotificationComponent,
        ApIconComponent,
        ApPersistenceModule,
        ApSignComponent,
        CommonModule,
        LoginAccordionModule,
        MijnLoginTemplateModule,
        SessiebeheerModule,
        SignModule,
        ReactiveFormsModule,
        ApInputComponent,
        ApCardComponent,
        BrowserModule,
        FingerprintjsProAngularModule.forRoot({
            loadOptions: {
                apiKey: '5DDg4uGk2Wl0pWL8bxMm',
                region: 'eu'
            }
        }),
        FormsModule
    ],
    exports: [Auth0loginWrapperComponent]
})
export class Auth0loginWrapperModule {}
